import reframe from 'reframe.js';

reframe(document.querySelectorAll('iframe.responsive-iframe'));
